export default {
    records: [],
    recordTypes: [],
    responsibleTypes: [],
    establishments: [],
    stats: null,
    selectedRecord: null,
    loading: false,
    error: null,
}
